/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import './ww-weapon-box.scss';
import { IWWWeaponInt } from '../../common/model/graphql-types';
import { WWWeaponImage } from './ww-weapon-image';
import { Accordion } from 'react-bootstrap';

interface IProps {
  weapon: IWWWeaponInt;
  level?: number[];
  onProfile?: boolean;
}

export const WWWeaponBox: React.FC<IProps> = ({ weapon, level, onProfile }) => {
  const [weaponType, setWeaponType] = useState('Pistols');
  const [finalWeaponEffect, setFinalWeaponEffect] = useState(null);

  useEffect(() => {
    setWeaponType(weapon.Weapon_Type);
  }, [weapon]);

  useEffect(() => {
    let param1 = null;
    let param2 = null;
    let param3 = null;
    let param4 = null;
    let param5 = null;
    let param6 = null;
    let param7 = null;

    if (weapon.Effect.includes('{1}')) {
      param1 = weapon.Array_1[level[0] - 1];
    }

    if (weapon.Effect.includes('{2}')) {
      param2 = weapon.Array_2[level[0] - 1];
    }

    if (weapon.Effect.includes('{3}')) {
      param3 = weapon.Array_3[level[0] - 1];
    }

    if (weapon.Effect.includes('{4}')) {
      param4 = weapon.Array_4[level[0] - 1];
    }

    if (weapon.Effect.includes('{5}')) {
      param5 = weapon.Array_5[level[0] - 1];
    }

    if (weapon.Effect.includes('{6}')) {
      param6 = weapon.Array_6[level[0] - 1];
    }

    if (weapon.Effect.includes('{7}')) {
      param7 = weapon.Array_7[level[0] - 1];
    }

    const newString = weapon.Effect.replaceAll(
      '{0}',
      `<b>${weapon.Array_0[level[0] - 1]}</b>`
    )
      .replaceAll('{1}', `<b>${param1}</b>`)
      .replaceAll('{2}', `<b>${param2}</b>`)
      .replaceAll('{3}', `<b>${param3}</b>`)
      .replaceAll('{4}', `<b>${param4}</b>`)
      .replaceAll('{5}', `<b>${param5}</b>`)
      .replaceAll('{6}', `<b>${param6}</b>`)
      .replaceAll('{7}', `<b>${param7}</b>`);
    setFinalWeaponEffect(newString);
  }, [level, weapon]);

  return (
    <>
      {onProfile ? (
        <Accordion className="ww-weapon-accordion">
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <div className={`ww-weapon-image rarity-${weapon.Rarity}`}>
                <WWWeaponImage id={weapon.ID} />
              </div>
              <span className={`ww-weapon-name rarity-${weapon.Rarity}`}>
                {weapon.Name} (R{level})
              </span>
            </Accordion.Header>
            <Accordion.Body>
              <div className="ww-content">
                <div
                  className={`skill-with-coloring`}
                  dangerouslySetInnerHTML={{
                    __html: finalWeaponEffect
                  }}
                />
                <div className="stats">
                  <p>
                    Stats at Level 90: ATK:{' '}
                    <strong>{weapon.Stat_primary}</strong> |{' '}
                    {weapon.Stat_secondary}:{' '}
                    <strong>{weapon.Stat_secondary_value}%</strong>
                  </p>
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      ) : (
        <>
          <div className="ww-weapon-box box">
            <div className="ww-header">
              <div className={`ww-image rar-${weapon.Rarity}`}>
                <WWWeaponImage id={weapon.ID} />
              </div>
              <div className="ww-data">
                <h4>
                  {weapon.Name}{' '}
                  {weapon.isNew && <span className="tag">New!</span>}
                </h4>
                <div className="ww-info">
                  <p>
                    Rarity:{' '}
                    <strong className={`rarity-ww rar-${weapon.Rarity}`}>
                      {weapon.Rarity}★
                    </strong>
                  </p>
                  <p>
                    Type: <strong>{weaponType}</strong>
                  </p>
                </div>
              </div>
            </div>
            <div className="ww-content">
              <div
                className={`skill-with-coloring`}
                dangerouslySetInnerHTML={{
                  __html: finalWeaponEffect
                }}
              />
            </div>
            <div className="ww-stats">
              <p>
                ATK (Lv.90): <strong>{weapon.Stat_primary}</strong>
              </p>
              <p>
                {weapon.Stat_secondary} (Lv.90):{' '}
                <strong>{weapon.Stat_secondary_value}%</strong>
              </p>
            </div>
          </div>
        </>
      )}
    </>
  );
};
